<template>
  <div v-if="completedOrders.length > 0">
    <h3 class="heading-category">Previous Orders</h3>
    <swiper
      :modules="modules"
      :autoplay="false"
      :keyboard="true"
      :scrollbar="false"
      :zoom="true"
      :slides-per-view="3"
    >
      <swiper-slide v-for="(order, index) in completedOrders" :key="index">
        <div class="slide">
          <span class="prev-order">{{ order.product.productName }}</span>
          <span
            v-for="(addon, idx) in order.variations"
            :key="idx"
            class="prev-order-addon"
          >
            {{ addon.name }}
          </span>
          <img
            src="/assets/icon/reorder.svg"
            class="reorder-icon"
            @click="addToCart(order)"
            alt="Reorder"
          />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<style scoped>
.swiper-slide {
  display: block;
}
.swiper-slide img {
  margin: 10px 0 10px 0px;
  pointer-events: auto;
}
.slide {
  margin-top: 0%;
  margin-bottom: 5%;
  margin-left: 20%;
  margin-right: 0%;
  position: relative;
}
.swiper .swiper-slide {
  padding: 0px 0px 0px 0px !important;
}
.swiper .swiper-slide img {
  width: auto;
  height: auto;
}
.heading-category {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  color: #1b1b1b;
  margin-bottom: 15px;
  margin-left: 20px;
}
.prev-order {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 19px;
  text-align: left;
  color: #1b1b1b;
  margin-bottom: 5px;
  margin-left: 0px;
  display: block;
}
.prev-order-addon {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
  display: block;
  text-align: left;
}
.reorder-icon {
  width: 24px !important;
  height: 24px !important;
  color: #00a676;
  position: absolute;
  right: 10px;
  top: 30px;
  cursor: pointer;
}
</style>

<script>
import { alertController } from "@ionic/vue";
import axios from "axios";
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default {
  components: { Swiper, SwiperSlide },
  data() {
    return {
      lastOrders: [],
      modules: [Autoplay, Keyboard, Pagination, Scrollbar, Zoom],
      cafeId: "",
      userId: "",
      cartOrders: [],
      completedOrders: [],
      toCartUpdate: false,
      cartOrderId: null,
      quantity: 1,
      totalCartPrice: 0,
      totalCartQty: 0,
      subTotalCartPrice: 0,
    };
  },
  computed: {
    cartList() {
      return this.cartOrders;
    },
  },
  methods: {
    async getCompletedOrders(userId, cafeId) {
      // Don't fetch cart orders if user is not logged in
      const token = localStorage.getItem("token");
      const isValidUserId =
        userId && userId !== "null" && userId !== "undefined" && userId !== "";
      const isValidToken =
        token && token !== "null" && token !== "undefined" && token !== "";

      if (!isValidUserId || !isValidToken) {
        this.completedOrders = [];
        return;
      }

      let axiosConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url =
        BASE_URI +
        "/cart/get-cart-orders/?userId=" +
        userId +
        "&cafeId=" +
        cafeId +
        "&status=collected";

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          throw err.response.status;
        });

      this.completedOrders =
        result && result.data.length ? await result.data : [];
    },
    async getCartOrders(userId, cafeId) {
      // Don't fetch cart orders if user is not logged in
      const token = localStorage.getItem("token");
      const isValidUserId =
        userId && userId !== "null" && userId !== "undefined" && userId !== "";
      const isValidToken =
        token && token !== "null" && token !== "undefined" && token !== "";

      if (!isValidUserId || !isValidToken) {
        this.cartOrders = [];
        return;
      }

      let axiosConfig = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url =
        BASE_URI +
        "/cart/get-cart-orders/?userId=" +
        userId +
        "&cafeId=" +
        cafeId +
        "&status=pending";

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          throw err.response.status;
        });

      this.cartOrders = result && result.data.length ? await result.data : [];

      for (let i = 0; i < this.cartOrders.length; i++) {
        this.totalCartQty += this.cartOrders[i].quantity;
        this.subTotalCartPrice += this.cartOrders[i].pricePerOrder;
      }
    },
    async addToCart(order) {
      for (let i = 0; i < this.cartList.length; i++) {
        if (
          this.cartList[i].product.id == order.product.id &&
          JSON.stringify(this.cartList[i].variations) ==
            JSON.stringify(order.variations)
        ) {
          let sumOfVariations = this.cartList[i].variations.reduce(
            (total, item) => total + item.price,
            0
          );

          this.quantity = parseInt(this.quantity + this.cartList[i].quantity);

          this.totalCartPrice +=
            (this.cartList[i].product.originalPrice + sumOfVariations) *
            this.quantity;

          this.toCartUpdate = true;
          this.cartOrderId = this.cartList[i].uuid;
        }
      }

      let paramsData = {};

      if (!this.toCartUpdate) {
        paramsData = {
          productId: order.product.id,
          variations: order.variations,
          quantity: order.quantity,
          pricePerOrder: order.pricePerOrder,
          instructions: order.instructions,
          userId: order.userId,
          cafeId: order.cafe.cafeId,
        };

        let axiosConfig = {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json;charset=UTF-8",
          },
        };

        await axios
          .post(BASE_URI + "/cart/create-cart-orders", paramsData, axiosConfig)
          .then((res) => {
            if (res.status == 201) {
              this.presentAlert("Your order has been added to cart.");

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((err) => {
            this.presentAlert("Sign in to continue.");

            setTimeout(() => {
              window.location.href = window.location.origin + "/welcome";
            }, 1000);
            throw err;
          });
      } else {
        paramsData = {
          id: this.cartOrderId,
          variations: order.variations,
          quantity: this.quantity,
          pricePerOrder: this.totalCartPrice,
          instructions: order.instructions,
          status: "pending",
        };

        let axiosConfig = {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json;charset=UTF-8",
          },
        };

        await axios
          .put(BASE_URI + "/cart/update-cart-orders", paramsData, axiosConfig)
          .then((res) => {
            if (res.status == 200) {
              this.presentAlert("Your order has been added to cart.");

              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((err) => {
            this.presentAlert("Sign in to continue.");

            setTimeout(() => {
              window.location.href = window.location.origin + "/welcome";
            }, 1000);
            throw err;
          });

        this.toCartUpdate = false;
        this.cartOrderId = order.uuid;
      }
    },
    async presentAlert(alertMsg) {
      const alert = await alertController.create({
        subHeader: alertMsg,
      });

      await alert.present();
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cafeId = urlParams.get("id") || "";
    const userId = localStorage.getItem("id") || null;
    localStorage.setItem("cafeId", cafeId);
    this.cafeId = cafeId;
    this.userId = userId;

    await this.getCompletedOrders(userId, cafeId);
    await this.getCartOrders(userId, cafeId);
  },
};
</script>
